import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reportErrorToNewRelic } from '../../utils/logging/logging-utils';

import styles from './error-boundary.scss';
import { TechnicalError } from '../../components/technical-error/TechnicalError';

class ErrorBoundary extends Component {

  static propTypes = {
    children: PropTypes.node,
    sessionId: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    sessionId: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      error: undefined,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const { sessionId } = this.props;
    reportErrorToNewRelic(error, {
      sessionId,
    });
  }

  render() {
    const {
      children,
    } = this.props;

    const { error } = this.state;

    if (error) {
      return (
        <div className={styles.app}>
          <main className={styles.main} id="main">
            <TechnicalError error={error} />
          </main>
        </div>
      );
    }

    return children;
  }
}

export default connect(state => ({
  sessionId: state.config.sessionId,
}))(ErrorBoundary);
